<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import draggable from "vuedraggable";

/**
 * Calendar component
 */
export default {
  page: {
    title: "Calendar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    FullCalendar,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Calendar",
      items: [
        {
          text: "Dashboard",
        },
        {
          text: "Calendar",
          active: true,
        },
      ],
      calendarOptions: {
        customButtons: {
          switchViewMonth: {
            text: 'Month',
            click: () => {
              if(!this.isLoadingGetList){
                this.calendarType = 'month'
                this.$refs.myCalendar.getApi().changeView('dayGridMonth')
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          switchViewWeek: {
            text: 'List',
            click: () => {
              if(!this.isLoadingGetList){
                this.calendarType = 'day'
                this.$refs.myCalendar.getApi().changeView('listWeek')
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonNext: {
            text: 'Next',
            icon: 'chevron-right',
            click: () => {
              if(!this.isLoadingGetList){
                this.$refs.myCalendar.getApi().next()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonPrev: {
            text: 'Prev',
            icon: 'chevron-left',
            click: () => {
              if(!this.isLoadingGetList){
                this.$refs.myCalendar.getApi().prev()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonToday: {
            text: 'Today',
            click: () => {
              if(!this.isLoadingGetList){
                this.$refs.myCalendar.getApi().today()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          }
        },
        headerToolbar: {
          left: "buttonPrev,buttonNext buttonToday",
          center: "title",
          right: "switchViewMonth,switchViewWeek",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "listWeek",
        themeSystem: "bootstrap",
        events: [],
        droppable: true,
        // eventResizableFromStart: true,
        dateClick: this.dateClicked,
        eventClick: this.showEvent,
        eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        draggable: true,
        editable: true,
        eventDrop: this.eventDrop
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      isLoadingGetList: false,
      list_error_messages: [],
      filter: {
        page: 1,
        paginate_count: 25,
        room_id: 0,
        subject_id: 0,
        item_id: 0
      },
      gridData: {
        data: [],
        total: 0,
      },
      calendarType: 'day',
      refreshCalendar: 0,
      selectedPost: {},
      loadingGetPost: false,
      errorGetPost: [],
      showModalDetails: false,
      roomList: [],
      subjectList: [],
      itemList: [],
      showFilterOptions: false,
      currentDate: new Date()
    };
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  async created(){
    this.token = await localStorage.getItem('authToken')
  
    this.getItemList()
    this.getSubjectList()
    this.getRoomList()
  
    this.getList();
  },
  mounted(){
    //
  },
  watch: {
    currentDate(oldValue, newValue){
      this.getList()
    }
  },
  methods: {
    getList(action = 'today'){

      let buttonPrev = document.querySelector('.fc-buttonPrev-button');
      let buttonNext = document.querySelector('.fc-buttonNext-button');
      let buttonToday = document.querySelector('.fc-buttonToday-button');
      let buttonWeek = document.querySelector('.fc-switchViewWeek-button')
      let buttonMonth = document.querySelector('.fc-switchViewMonth-button')

      buttonPrev.disabled = true
      buttonNext.disabled = true
      buttonToday.disabled = true

      buttonPrev.classList.add('btn-light');
      buttonNext.classList.add('btn-light');
      buttonToday.classList.add('btn-light');
      buttonWeek.classList.add('btn-light');
      buttonMonth.classList.add('btn-light');
      
      this.isLoadingGetList = true;
      this.calendarOptions.events = [];

      let filter = 'room_id=' + this.filter.room_id + '&subject_id=' + this.filter.subject_id + '&item_id=' + this.filter.item_id
      
      let calendar = this.$refs.myCalendar.getApi()
      let date = null

      if(this.calendarType == 'month'){
        date = calendar.getDate().getFullYear() + '-' + (calendar.getDate().getMonth() + 1) + '-01'
        filter += '&view=month&date=' + date
      } else {
        date = calendar.getDate().getFullYear() + '-' + (calendar.getDate().getMonth() + 1) + '-' + calendar.getDate().getDate()
        filter += '&view=day&date=' + date
      }

      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/post/getIndex?' + filter, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.gridData = res.data;
        this.list_error_messages = [];

        this.gridData.data.map((item, index) => {

          let color = 'bg-success';
          if(!item.is_editable){
            color = 'bg-dark';
          }

          if(item.is_announcement){
            color = 'bg-danger';
          }

          this.calendarOptions.events.push({
            id: item.id,
            title: item.room.name + ' - ' + (item.is_announcement ? 'ANNOUNCEMENT' : item.subject.name),
            start: item.date,
            className: color
          });
        });
      })
      .catch(err => {
        this.err = err;
      })
      .finally(() => {
        this.isLoadingGetList = false;
        buttonPrev.disabled = false;
        buttonNext.disabled = false;
        buttonToday.disabled = false;
        buttonWeek.disabled = false
        buttonMonth.disabled = false

        buttonPrev.classList.remove('btn-light');
        buttonNext.classList.remove('btn-light');
        buttonToday.classList.remove('btn-light');
        buttonWeek.classList.remove('btn-light');
        buttonMonth.classList.remove('btn-light');
      });
    },
    /**
     * Modal form submit
     */
    // eslint-disable-next-line no-unused-vars
    handleSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const title = this.event.title;
        const category = this.event.category;
        let calendarApi = this.newEventData.view.calendar;

        this.currentEvents = calendarApi.addEvent({
          id: this.newEventData.length + 1,
          title,
          start: this.newEventData.date,
          end: this.newEventData.date,
          classNames: [category],
        });
        this.successmsg();
        this.showModal = false;
        this.newEventData = {};
      }
      this.submitted = false;
      this.event = {};
    },
    /**
     * Modal open for add event
     */
    dateClicked(info) {
      
      let date = new Date();

      if(this.$store.getters['auth/isAdmin']){
        this.$router.push({name: "Create Post", params: {date: info.dateStr}})
        return
      }
      
      if(info.dateStr < new Date(date.setDate(date.getDate())).toISOString().split('T')[0]){
        Swal.fire("Error!", "You are not allowed to create Post on past date", "error");
        return
      }

      if(info.dateStr <= new Date(date.setDate(date.getDate())).toISOString().split('T')[0]){
        Swal.fire("Error!", "You are not allowed to create Post today", "error");
        return
      }

      if(info.dateStr <= new Date(date.setDate(date.getDate() + 1)).toISOString().split('T')[0]){
        Swal.fire("Error!", "You can only create Post day after tomorrow", "error");
        return
      }
      
      this.$router.push({name: "Create Post", params: {date: info.dateStr}})
    },
    /**
     * Modal open for edit event
     */
    showEvent(info) {
      this.showModalDetails = true
      this.loadingGetPost = true
      this.errorGetPost = []

      this.selectedPost = {
        is_editable: false
      }

      axios.get(process.env.VUE_APP_API + '/post/' + info.event.id, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.selectedPost = res.data.data;
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.errorGetPost = err.response.data.data;
            }
          }
        }
      })
      .finally(() => {
        this.loadingGetPost = false;
      });
    },
    closeModal() {
      this.eventModal = false;
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    async eventDrop(events){
      
      this.isLoadingGetList = true
      let post = null

      await axios.get(process.env.VUE_APP_API + '/post/' + events.event.id, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        post = res.data.data;

        if(post.is_editable){
          this.handleEventDrop(events)
        } else {
          Swal.fire("Error!", "You are not authorized to perform the action", "error");
          this.getList()
        }
      })
    },
    handleEventDrop(events){
      let new_date = events.event.startStr
      
      let formattedDate = new Date(new_date).toLocaleDateString('en-GB');
      let [day, month, year] = formattedDate.split('/');
      let date = `${day}-${month}-${year}`;

      Swal.fire({
        title: "Change Date?",
        text: "You are about to change Post to " + date,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, change it!"
      }).then(result => {
        if (result.value) {
          
          axios.post(process.env.VUE_APP_API + '/post/' + events.event.id +'/move', {
            new_date: new_date
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Success!", "Successfully move Post to new date", "success");
          })
          .catch(err => {
            if('response' in err){
              if('data' in err.response){
                if('message' in err.response.data){
                  Swal.fire("Error!", err.response.data.message, "error");
                }
              }
            }
          })
          .finally(() => {
            this.getList()
          })
        } else {
          this.getList()
        }
      });
    },
    renderCalendarRoom(arg){
      var title = arg.event.title.split(' - ');
      var room_name = title[0];

      return room_name
    },
    renderCalendarTitle(arg){
      var title = arg.event.title.split(' - ');
      var event_title = title[1];

      return event_title
    },
    renderFileIcon(attachment){
      let filetype = attachment.name;
      
      if(filetype.includes('png') || filetype.includes('jpg') || filetype.includes('jpeg') || filetype.includes('gif') || filetype.includes('svg')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word') || filetype.includes('doc') || filetype.includes('docx')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel') || filetype.includes('xls') || filetype.includes('xlsx')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint') || filetype.includes('ppt') || filetype.includes('pptx')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    },
    onClickDownloadAttachment(attachment){
      window.open(attachment.download_link, '_blank');
    },
    getItemList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/item')
      .then(res => {
        this.itemList = res.data.data;

        this.itemList.unshift({
          id: 0,
          name: 'Select All Items'
        });
      })
    },
    getSubjectList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/subject')
      .then(res => {
        this.subjectList = res.data.data;

        this.subjectList.unshift({
          id: 0,
          name: 'Select All Subjects'
        });
      })
    },
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/room/getIndex', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.roomList = res.data.data;

        this.roomList.unshift({
          id: 0,
          name: 'Select All Rooms'
        });
      })
    },
    onClickEdit(){
      if(this.selectedPost.is_editable){
        this.$router.push({ name: "Edit Post", params: { id: this.selectedPost.id } });
      } else {
        Swal.fire("Error!", "You are not allowed to edit this Post", "error");
      }
    },
    onClickDelete(){

      let text = "You are about to delete selected Post. You will NOT be able to restore it back!";
      if(this.selectedPost.is_announcement){
        text = "You are about to delete all Announcements in "+ this.selectedPost.human_date  +". You will NOT be able to restore it back!";
      }

      Swal.fire({
        title: "Delete Post?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/post/' + this.selectedPost.id, {
            _method: 'DELETE'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Deleted!", 'Post has been removed', "success");
            this.showModalDetails = false
            this.getList();
          })
          .catch(err => {
            if('response' in err){
              if('data' in err.response){
                if('message' in err.response.data){
                  this.list_error_messages = err.response.data.data;
                }
              }
            }
          })
        }
      });
    },
    isAuthUser(){
      if(this.selectedPost){
        if(this.selectedPost.user){
          return this.$store.getters['auth/loggedIn'].id == this.selectedPost.user.id
        }
      }

      return false
    },
    renderDescription(text){
      /* eslint-disable no-useless-escape */
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      let formattedText = text.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">Click here to open link</a>');
      
      // Replace new lines with <br> tags
      formattedText = formattedText.replace(/\r\n|\n|\r/g, '<br>');
      
      return formattedText;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card plan-box">
          <div class="card-body">
            <div class="col-12 text-center plan-btn mb-3">
              <a
                @click="showFilterOptions = !showFilterOptions"
                class="btn btn-primary btn-sm position-relative"
              >{{ showFilterOptions ? 'Hide' : 'Show' }} Filter Options</a>
            </div>
            <div class="mt-3 bg-light py-2 row" v-if="showFilterOptions">
              <div class="col-sm mb-1">
                <select
                  id="inputRoom"
                  v-model="filter.room_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="room.id" v-for="(room, index) in roomList" :key="`room_${index}`">{{room.name}}</option>
                </select>
              </div>
              <div class="col-sm mb-1">
                <select
                  id="inputSubject"
                  v-model="filter.subject_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="subject.id" v-for="(subject, index) in subjectList" :key="`subject_${index}`">{{subject.name}}</option>
                </select>
              </div>
              <div class="col-sm mb-1">
                <select
                  id="inputItem"
                  v-model="filter.item_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="item.id" v-for="(item, index) in itemList" :key="`item_${index}`">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="app-calendar">
              <FullCalendar
                :options="calendarOptions"
                :header="calendarOptions.headerToolbar"
                ref="myCalendar"
              >
              <template v-slot:eventContent='arg'>
                <strong>{{ renderCalendarRoom(arg) }}</strong>
                <div class="small text-white" v-if="calendarType == 'day'">{{ renderCalendarTitle(arg) }}</div>
              </template>
              </FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Details Modal -->
    <b-modal
      v-model="showModalDetails"
      title="Post Details"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
      <div slot="modal-title">
        Post Details
      </div>
      <div class="row">
        <div class="col-12">
          <p class="card-text placeholder-glow" v-if="loadingGetPost">
            <span class="placeholder col-7"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
          </p>
          <div class="alert alert-danger" v-if="errorGetPost.length > 0">
            <ul>
              <li v-for="(error, index) in errorGetPost" :key="`error_${index}`">{{ error }}</li>
            </ul>
          </div>
        </div>

        <div class="row" v-if="!loadingGetPost && errorGetPost.length == 0">
          <div class="col-12">
            <strong>Date :</strong> {{ selectedPost.human_date }}
          </div>
          <div class="col-12" v-if="'year' in selectedPost">
            <span class="badge me-1 bg-primary">{{ selectedPost.year.name }}</span>
            <span class="badge me-1 bg-success">{{ selectedPost.room.name }}</span>
          </div>
          <div class="row mt-4" v-if="'description' in selectedPost">
            <div class="col-12 mt-1">
              <span class="badge me-1 even-larger-badge bg-info" v-if="selectedPost.subject">{{ selectedPost.subject.name }}</span>
              <span class="badge me-1 even-larger-badge bg-dark" v-if="selectedPost.item">{{ selectedPost.item.name }}</span>
              <span class="badge me-1 even-larger-badge bg-danger" v-if="selectedPost.is_announcement">ANNOUNCEMENT</span>
              <h5 class="font-size-14 mt-3" v-html="renderDescription(selectedPost.description)"></h5>
            </div>
            <div class="col-12 mt-3" v-if="selectedPost.attachments.length">
              <div v-for="(attachment, index) in selectedPost.attachments" :key="`attachment_${index}`" class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-truncate">
                    <i :class="renderFileIcon(attachment)"></i> {{ attachment.name.length > 20 ? attachment.name.substring(0, 20) + '...' : attachment.name }}
                    <button type="button" class="btn btn-link btn-sm text-primary" @click="onClickDownloadAttachment(attachment)">Download</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3" v-if="selectedPost.protected_files.length">
              <strong class="font-size-14 mb-2"><i class="bx bx-lock-alt"></i> Protected Files</strong>
              <div v-for="(attachment, index) in selectedPost.protected_files" :key="`attachment_${index}`" class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-truncate">
                    <i :class="renderFileIcon(attachment)"></i> {{ attachment.name.length > 20 ? attachment.name.substring(0, 20) + '...' : attachment.name }}
                    <button type="button" class="btn btn-link btn-sm text-primary" @click="onClickDownloadAttachment(attachment)">Download</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4" v-if="'user' in selectedPost">
            <div class="col-12 mb-3">
              <strong class="font-size-14">Posted By</strong>
            </div>
            <div class="col-2">
              <div class="avatar-xs">
                <span class="avatar-title rounded-circle">{{selectedPost.user.name.charAt(0)}}</span>
              </div>
            </div>
            <div class="col-10">
              <h5 class="font-size-14 mb-1">
                <div class="text-dark">{{selectedPost.user.name}}</div>
                <div class="text-muted small mt-1" v-if="selectedPost.user.contact_no">{{selectedPost.user.contact_no}}</div>
                <div class="text-muted small mt-1" v-if="!selectedPost.user.contact_no"><i>No contact number</i></div>
              </h5>
            </div>
          </div>
        </div>
        <div class="col-12 row justify-space-between mt-4">
          <div class="col" v-if="selectedPost.is_editable">
            <button type="button" class="btn btn-primary me-2" @click="onClickEdit()">Edit</button>
            <button type="button" class="btn btn-danger" @click="onClickDelete()">Delete</button>
          </div>
          <div class="col me-0 right">
            <button :disabled="loadingGetPost" class="btn btn-light" type="button" @click="showModalDetails = false">Close</button>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
<style>
  .fc-event-time, .fc-list-event-time, .fc-daygrid-event-dot, .fc-list-event-dot {
    display: none !important;
  }
  .fc-event-title, .fc-list-event-title {
    font-weight: normal !important;
    flex-grow: 0 !important;
  }
  .fc-event-title, .fc-list-event-title {
    font-size: 12px !important;
  }
  .fc-event {
    text-align: left !important;
  }
  /* .fc-list-event-title, .fc-list-event-graphic, .fc-event, .fc-daygrid-event-harness {
    background-color: green !important;
  } */
  .fc-daygrid-event-harness {
    margin-bottom: 3px;
  }
  .fc .fc-popover {
    z-index: 99 !important;
  }
  .fc .fc-list-event:hover td {
    background-color: #556ee6 !important;
  }
  .fc-view-harness .fc-view-harness-active {
    height: 70vh !important;
  }
  .fc .fc-more-popover .fc-popover-body {
    max-height: 250px !important;
    overflow: scroll !important;
    overflow-x: hidden !important;
  }
</style>